module.exports = __webpack_public_path__ + "letterFadePositionInRight.gif";